export const setSearchdata = (data) => {
    return {
      type: 'SET_SEARCH',
      payload: data
    };
  };